<template>
    <div id="novel_create">
        <div class="novel_create">
            <div class="novel_create1 cursor_1" @click="toHome">
                <img src="@/assets/image/icon_right.png" alt="">
                创建作品
            </div>
            <div class="novel_create2">
                <div class="novel_create2_1">
                    <!-- 核心受众 -->
                    <div class="novel_create3">
                        <div class="novel_create4">核心受众</div>
                        <div class="novel_create5" v-for="(item, i) in sex" :key="i" @click.stop="getSex(item.value)">
                            <img :src="novelInfo.sex.includes(item.value) ? iconSelect[1] : iconSelect[0]"
                                class="cursor_1" alt="">
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="novel_create6"></div>

                    <!-- 作品类型 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>作品类型</div>
                        <div class="novel_create8">
                            <div class="novel_create8_1 cursor_1" v-if="novelInfo.typeName" @click="openLabel3">
                                {{ novelInfo.typeName }}
                                <img :src="iconSelect[4]" @click.stop="delLabel(0, '类型')" alt="">
                            </div>
                            <div v-if="!novelInfo.typeName" class="novel_create9 cursor_1" @click="openLabel3">
                                <img :src="iconSelect[3]" alt="">
                                {{ novelInfo.typeName ? '更换类型' : '添加类型' }}
                            </div>
                        </div>
                    </div>

                    <!-- 文笔风格 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>作品风格</div>
                        <div class="novel_create8">
                            <div class="novel_create8_1 cursor_1" v-for="(item, i) in novelInfo.stylisticNames" :key="i"
                                @click="openLabel4">
                                {{ item }}
                                <img :src="iconSelect[4]" @click.stop="delLabel(i, '风格')" alt="">
                            </div>
                            <div v-if="novelInfo.stylisticNames.length < 10" class="novel_create9 cursor_1"
                                @click="openLabel4">
                                <img :src="iconSelect[3]" alt="">
                                添加标签
                            </div>
                        </div>
                    </div>
                    <div class="novel_create6"></div>
                    <!-- 生成集数 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>生成集数</div>
                        <div class="create_novel7">
                            <el-input v-model="novelInfo.chaptersNumber" type="number"
                                :placeholder="'1~' + maxChapterLen"></el-input>
                        </div>
                    </div>
                    <div class="novel_create6"></div>
                    <!-- 每集时长 -->
                    <div class="novel_create3">
                        <div class="novel_create4"><span>*</span>每集时长</div>
                        <div class="create_novel7">
                            <el-input v-model="novelInfo.duration" type="number"
                                :placeholder="'请输入' + durationMin + '-' + durationLen + '（分钟）'"></el-input>
                        </div>
                    </div>
                    <div class="novel_create6"></div>
                    <!-- 后端动态生成表单内容 -->
                    <!-- {{ novelInfo }} -->
                    <template v-for="(item, index) in curForm">
                        <div :key="index" class="novel_create3" v-if="item.display">
                            <div class="novel_create4" v-if="!item.required">{{ item.name }}<span>(非必填)</span></div>
                            <div class="novel_create4" v-else><span>*</span>{{ item.name }}</div>
                            <div class="create_novel7 create_novel30">
                                <el-input v-if="item.name === '作品名称'" v-model="novelInfo[item.key]"
                                    @input="insertTextCaChe" :ref="item.writeType" :maxlength="150" show-word-limit
                                    placeholder="请输入作品名称">
                                </el-input>
                                <el-input v-else v-model="novelInfo[item.key]" type="textarea" @input="insertTextCaChe"
                                    :ref="item.writeType" :autosize="{ minRows: 3, maxRows: 8 }"
                                    :maxlength="item.maxLength" show-word-limit :placeholder="item.placeholder">
                                </el-input>
                                <!-- 停止生成按钮 -->
                                <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                    v-if="streamStatus && requireCurItem.key === item.key && item.name !== '作品名称'">
                                </AIStopCreate>
                            </div>
                            <div class="create_novel16 cursor_1 AIicon" v-if="item.helpWrite"
                                @click="openPopup(index, item)"></div>
                            <div class="loading_text_create" v-if="streamStatus && requireCurItem.key == item.key">
                                <img src="@/assets/image/loading.png" alt="">
                            </div>
                        </div>
                        <div class="novel_create6"></div>
                    </template>

                    <div class="novel_create3">
                        <div class="novel_create4"></div>
                        <div class="create_novel17">
                            <div class="create_novel20">
                                <el-button :loading="loading" type="warning"
                                    class="create_novel14 create_novel15 cursor_1" @click="createNovel">
                                    {{ loading ? '正在创建...' : '确认创建' }}
                                </el-button>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
        <createHelp ref="createHelp" @getRequire="getRequire" />
        <createLabel3 ref="createLabel3" @getLable="getLable3" />
        <createLabel4 ref="createLabel4" @getLable="getLable4" />
        <!-- <createLabel ref="createLabel" @getLable="getLable" /> -->
        <!-- <createLabel2 ref="createLabel2" @getLable="getLable2" /> -->
        <delPpopup ref="delPopup" @confirm="confirm"></delPpopup>
    </div>
</template>

<script>
import data from '@/assets/data';
import createHelp from '@/components/novel_create_help.vue';
import createLabel from '@/components/novel_create_label.vue';
import createLabel3 from '@/components/novel_create_label3.vue';
import createLabel4 from '@/components/novel_create_label4.vue';
import api from '@/api/api';
import SApi from '@/api/script'
import longNovel from '@/api/longNovel';
import delPpopup from '@/components/del_popup.vue';
import _ from 'lodash'
export default {
    components: {
        createHelp, createLabel, delPpopup, createLabel4, createLabel3
    },
    data() {
        return {
            iconSelect: data.iconSelect,//选择图标
            sex: data.scriptSex, //性别选择
            //创建小说表单
            novelInfo: {
                sex: [],//核心受众
                typeName: '',//作品类型
                stylisticNames: [], //文笔风格,接口是string类型，提交的时候进行转换就行了，使用数据更适合处理业务逻辑
                chaptersNumber: '',//集数
                duration: '',//时长
                plot: '',//主线剧情
                protagonistNames: '',// 角色信息
                scriptName: '',//作品名称
                requirement: '',//作品要求
                introduction: '',//作品简介
            },
            //必填项字段,移除单选按钮这些，进行验证
            verify: ['typeName', 'stylisticNames', 'chaptersNumber', 'duration', 'scriptName', 'protagonistNames', 'introduction'],
            options: [], //类型
            requireIndex: null, //帮写要求 0作品名称 1角色信息 2作品简介
            createBtn: false, //判断填写完成
            streamStatus: false, //流式请求
            streamIndex: 0, //流式请求下标
            streamLast: false,//流式请求最后一条
            debounceTimer: null, //防抖定时器
            typingTimer: null, // 打字效果定时器
            maxChapterLen: 100,
            durationLen: 30,//每集时长最高30
            durationMin: 2,//每集时长最低2
            refType: null,//滚动ref对象
            loading: false,//加载
            cacheKey: 'script_novel_add',
            curForm: [],//自定义的文本内容
            appendFormData: [{
                "name": "作品名称",
                "key": "scriptName",
                "helpWrite": true,
                "writeType": "script_name",
                "required": true,
                "sort": 5,
                "display": true,
                "placeholder": "请输入作品名称",
                "maxLength": 150
            },
            {
                "name": "角色信息",
                "key": "protagonistNames",
                "helpWrite": true,
                "writeType": "script_role",
                "required": true,
                "sort": 6,
                "display": true,
                "placeholder": "请输入角色信息",
                "maxLength": 10000
            },
            {
                "name": "作品要求",
                "key": "requirement",
                "helpWrite": false,
                "writeType": "",
                "required": false,
                "sort": 7,
                "display": true,
                "placeholder": "请输入您对作品的其他要求，例如:您偏爱的写作风格、独特的世界观、巧妙的伏笔、跌宕起伏的情节，以及想要探讨的主题深度等",
                "maxLength": 3000
            }
                , {
                "name": "作品简介",
                "key": "introduction",
                "helpWrite": true,
                "writeType": "script_introduction",
                "required": true,
                "sort": 8,
                "display": true,
                "placeholder": "请输入作品简介",
                "maxLength": 3000
            }
            ]
        }
    },
    beforeDestroy() {
        this.clearTime()
    },
    created() {
        this.getUserLoginState(false)
        this.init()
    },
    methods: {
        //初始化参数
        init() {
            longNovel.initLongNovelFromParams({ md: 'script' }).then((res) => {
                if (res.code == 200) {
                    if (res.data && res.data.length > 0) {
                        this.curForm = res.data.concat(this.appendFormData)
                        this.curForm = this.curForm.filter(item => {
                            this.$set(this.novelInfo, item.key, '')
                            if (item.required && item.display) {
                                this.verify.push(item.key)
                            }
                            return item
                        })
                    }
                    // console.log('res.data=', this.curForm)
                    let novel = JSON.parse(localStorage.getItem(this.cacheKey))
                    if (novel && Object.keys(novel).length > 0) {
                        this.$confirm('是否填写数据', '提示', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(() => {
                            this.novelInfo = novel
                        }).catch(() => {
                            localStorage.removeItem(this.cacheKey)
                        });
                    }
                }
            })
        },
        //@input 事件
        insertTextCaChe() {
            localStorage.setItem(this.cacheKey, JSON.stringify(this.novelInfo))
        },
        getCache(length) {
            let novel = JSON.parse(localStorage.getItem(this.cacheKey))
            console.log(novel)
            if (novel && Object.keys(novel).length > 0) {
                this.$confirm('是否填写数据', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.novelInfo = novel
                }).catch(() => {
                    localStorage.removeItem(this.cacheKey)
                });
            }
        },
        getStyle() {
            api.getParameter('pcxscs', 'style').then((res) => {
                if (res.code == 200) {
                    res.data[0].children.forEach(item => {
                        let children = item.placeholder.split(',');
                        let childrenArray = children.map(child => ({ value: child, label: child }));
                        this.options.push({
                            value: item.paramName,
                            label: item.paramName,
                            children: childrenArray
                        });
                    });
                }
            })
        },
        toHome() {
            if (this.hasValues()) {
                this.$refs.delPopup.openPrompt(3)
            } else {
                // this.$emit('toList')
                this.$router.replace({ path: '/scriptList' });
            }
        },
        hasValues() {
            for (const key in this.novelInfo) {
                if (this.verify.includes(key)) {
                    const value = this.novelInfo[key];
                    // 检查数组类型（非空数组才视为有值）
                    if (Array.isArray(value)) {
                        if (value.length > 0) return true;
                        continue; // 空数组不算有值，继续检查其他字段
                    }
                    // 检查字符串类型（非空字符串才视为有值）
                    if (typeof value === 'string') {
                        if (value.trim() !== '') return true;
                        continue;
                    }
                    // 检查数字类型（0也算有效值）
                    if (typeof value === 'number') {
                        return true;
                    }
                    // 检查布尔值（false也算有效值）
                    if (typeof value === 'boolean') {
                        return true;
                    }
                    // 检查对象类型（非空对象才视为有值）
                    if (typeof value === 'object' && value !== null) {
                        if (Object.keys(value).length > 0) return true;
                        continue;
                    }
                }
            }
            return false;
        },
        confirm() {

            this.$router.push({ path: '/' });
        },
        // 作品类型
        handleChange(value) {
            this.novelInfo.typeName = value[1]
            // this.empty()
        },
        // 核心受众
        getSex(value) {
            let index = this.novelInfo.sex.indexOf(value)
            if (index != -1) {
                this.novelInfo.sex.splice(index, 1)
            } else {
                this.novelInfo.sex.push(value)
            }
        },
        // 选择标签
        openLabel() {
            this.$refs.createLabel.openLable(this.novelInfo.labelNames);
        },
        // 选择文笔风格标签
        openLabel2() {
            this.$refs.createLabel2.openLable(this.novelInfo.style);
        },
        // 作品类型
        openLabel3() {
            this.$refs.createLabel3.openLable(this.novelInfo.typeName);
        },
        //作品风格标签
        openLabel4() {
            this.$refs.createLabel4.openLable(this.novelInfo.stylisticNames);
        },
        // 获取标签
        getLable(i) {
            this.novelInfo.labelNames = i
            // this.empty()
        },
        // 获取文笔风格
        getLable2(i) {
            this.novelInfo.style = i
            // this.empty()
        },
        // 获取作品类型
        getLable3(i) {
            this.novelInfo.typeName = i
        },
        getLable4(i) {
            this.novelInfo.stylisticNames = i
        },
        // 删除标签
        delLabel(i, type) {
            this.$confirm('是否删除标签？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (type === '标签') {
                    this.novelInfo.labelNames.splice(i, 1)
                } else if (type === '风格') {
                    this.novelInfo.stylisticNames.splice(i, 1)
                } else if (type === '类型') {
                    this.novelInfo.typeName = ''
                }
                // this.empty();
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //验证必填字段
        checking() {
            // console.log('this.verify=', this.verify)
            return Object.keys(this.novelInfo).some(key => {
                if (this.verify.includes(key)) {
                    const value = this.novelInfo[key];

                    // 检查数组类型（非空数组才视为有值）
                    if (Array.isArray(value)) {
                        if (!value.length) {
                            return true
                        }
                    }

                    // 检查字符串类型（非空字符串才视为有值）
                    if (typeof value === 'string') {
                        if (value.trim() === '') {
                            return true
                        }
                    }
                    // 检查对象类型（非空对象才视为有值）
                    if (typeof value === 'object' && value !== null) {
                        if (!Object.keys(value).length) {
                            return true
                        }
                    }
                }
                return false
            })
        },
        // 检测是否填写完成
        empty() {
            if (this.checking()) {
                this.createBtn = false
            } else {
                this.createBtn = true
            }
        },
        /**
         * @description
         * 点击AI帮写的逻辑
         * 必须几个：性别，作品类型，文笔风格
         * 角色信息 --》需要必须几个，主线剧情 i索引 1
         * 作品名称 --》需要必须几个，主线剧情、角色信息 i索引 0
         * 作品简介 --》需要必须几个，主线剧情、作品名称 i索引 2
         */
        validateForm(i, item) {
            const validationRules = [
                {
                    condition: () => this.streamStatus,
                    message: '请等待AI生成结束！'
                },
                {
                    condition: () => !this.novelInfo.sex.length,
                    message: '请选择核心受众！'
                },
                {
                    condition: () => this.novelInfo.typeName === '',
                    message: '请选择作品类型！'
                },
                {
                    condition: () => this.novelInfo.stylisticNames.length === 0,
                    message: '请选择作品风格！'
                },
                {
                    condition: () => !Number(this.novelInfo.chaptersNumber),
                    message: '请输入生成集数！'
                },
                {
                    condition: () => {
                        if (Number(this.novelInfo.chaptersNumber) && Number(this.novelInfo.chaptersNumber) > this.maxChapterLen) {
                            this.novelInfo.chaptersNumber = this.maxChapterLen
                            return true
                        }
                        return false
                    },
                    message: `生成集数超过${this.maxChapterLen}，已同步最高生成集数`
                },
                {
                    condition: () => !Number(this.novelInfo.duration),
                    message: '请输入每集时长！'
                },
                {
                    condition: () => {
                        if (this.novelInfo.duration && Number(this.novelInfo.duration) < this.durationMin) {
                            this.novelInfo.duration = this.durationMin
                            return true
                        }
                        return false
                    },
                    message: `每集时长小于${this.durationMin}分，已同步最低时长`
                },
                {
                    condition: () => {
                        if (this.novelInfo.duration && Number(this.novelInfo.duration) > this.durationLen) {
                            this.novelInfo.duration = this.durationLen
                            return true
                        }
                        return false
                    },
                    message: `每集时长超过${this.durationLen}分，已同步最高时长`
                },
                {
                    //判断自定义内容的逻辑
                    condition: () => {
                        let msg = ''
                        if (!item.required) return msg
                        let btArr = this.curForm.filter(v => v.required && v.display)
                        let curIndex = btArr.findIndex(i => i.name === item.name)
                        // console.log('btArr=', btArr.length,'curIndex===',curIndex)
                        //直接从第2个开始
                        if (curIndex === 0) return msg
                        let flag = {}
                        for (let j in btArr) {
                            if (!this.novelInfo[btArr[j].key].trim()) {
                                flag = { index: j, name: btArr[j].name, msg: `请输入${btArr[j].name}` }
                                break
                            }
                        }
                        // console.log('flag=', flag)
                        if (Object.keys(flag).length > 0) {
                            if (curIndex === flag.index && curIndex === btArr.length - 1) {
                                // console.log("这是最后一个元素且满足flag条件");
                                msg = flag.msg
                            } else {
                                if (curIndex > flag.index) {
                                    // console.log("这是在当前之前的某一个");
                                    msg = flag.msg
                                } else {
                                    //这是当前的逻辑
                                }
                            }
                        }
                        return msg
                    },
                    message: ''
                },
                {
                    //作品名称
                    condition: () => i == 2 && !this.novelInfo.scriptName.trim(),
                    message: '请填写作品名称'
                },

            ];

            for (const rule of validationRules) {
                //特殊处理
                if (!rule.message) {
                    let msg = rule.condition()
                    console.log('msg=', msg)
                    if (msg) {
                        this.$message({
                            message: msg,
                            type: 'warning'
                        });
                        return false;
                    }
                    return true
                } else {
                    if (rule.condition()) {
                        this.$message({
                            message: rule.message,
                            type: 'warning'
                        });
                        return false;
                    }
                }

            }
            return true;
        },
        //帮写提示
        openPopup(i, item) {
            if (this.showLoginPage()) return
            if (!this.validateForm(i, item)) {
                return;
            }
            this.requireCurItem = item
            this.$refs.createHelp.open(item.name);
        },
        //帮写提示词
        getRequire(item) {
            const baseParams = {
                ...this.novelInfo,
                menAndWomen: this.novelInfo.sex.join(','),//性别
                style: this.novelInfo.typeName,//作品类型
                label: this.novelInfo.stylisticNames.join(','),//作品风格
                name: this.novelInfo.scriptName,
                novelName: this.novelInfo.scriptName,
                scriptName: this.novelInfo.scriptName,
                protagonists: this.novelInfo.protagonistNames,
                platform: 1,//平台
                requirement: item, //弹窗填写的内容
            };

            //帮写要求 0作品名称 1角色信息 2作品简介
            if (Object.keys(this.requireCurItem).length > 0) {
                this.novelInfo[this.requireCurItem.key] = ''
                this.getStream(this.requireCurItem.writeType, baseParams);
            }
        },
        getStream(type, params) {
            this.AIWrite({
                length: '中',
                haveId: false,
                // djold: true,
                type: type,
                params: params,
                success: (res) => {
                    this.streamStatus = true
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // api.novelHelpWrite(aiType, params).then((res) => {
            //     if (res.code === 200) {
            //         this.streamStatus = true
            //         this.refType = type
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.$message.warning(res.msg)
            //     }
            // })
        },
        //销毁定时器
        clearTime() {
            clearTimeout(this.debounceTimer);
            clearInterval(this.typingTimer);
            this.streamStatus = false
            this.streamLast = false
            this.streamIndex = 0
            this.refType = null
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex, this.AIStreamType).then((res) => {
                    if (res.code === 200) {
                        if (res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            let combinedText = '';
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item;
                                }
                            });
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0;
                                    this.streamLast = true
                                }
                                if (this.streamLast) {
                                    this.streamStatus = false;
                                    this.streamLast = false;
                                    this.refType = null
                                    this.insertTextCaChe()
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    this.$message.success('AI生成完成！');
                                    // this.empty()
                                } else {
                                    this.getStreamContent(id);
                                }
                            });
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTime()
                    }
                }).catch(() => {
                    this.refType = null
                });
            }, 500);
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0;
            if (this.typingTimer) {
                clearInterval(this.typingTimer);
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    if (Object.keys(this.requireCurItem).length > 0) {
                        this.novelInfo[this.requireCurItem.key] += text[index]
                    }

                    index++;
                    this.$nextTick(() => {
                        const inputRef = this.$refs[this.requireCurItem.writeType];
                        if (!inputRef) return;
                        const inputInstance = Array.isArray(inputRef) ? inputRef[0] : inputRef;
                        const textarea = inputInstance?.$el?.querySelector('.el-textarea__inner');
                        if (textarea) {
                            // 滚动到底部
                            console.log(10)
                            textarea.scrollTop = textarea.scrollHeight;
                        }
                    });
                } else {
                    clearInterval(this.typingTimer);
                    if (callback) {
                        callback();
                    }
                }
            }, 20);
        },
        //创建小说事件
        createNovel() {
            if (this.showLoginPage()) return
            if (this.streamStatus) {
                this.$message({
                    message: '请等待AI生成结束！',
                    type: 'warning'
                });
                return
            }
            let item = _.cloneDeep(this.novelInfo);
            // item.stylisticNames = item.stylisticNames.join(',')
            // item.sex = item.sex.join(',')
            if (!item.sex.length) {
                this.$message.warning(`请选择核心受众`);
                return
            }
            if (!item.typeName) {
                this.$message.warning(`请选择作品类型`);
                return
            }
            if (!item.stylisticNames.length) {
                this.$message.warning(`请选择作品风格`);
                return
            }
            if (!item.chaptersNumber) {
                this.$message.warning(`请输入生成集数`);
                return
            }
            if (Number(item.chaptersNumber) > this.maxChapterLen) {
                this.$message.warning(`生成集数超过${this.maxChapterLen}，已同步最高生成集数`);
                this.novelInfo.chaptersNumber = this.maxChapterLen
                return
            }
            if (!item.duration) {
                this.$message.warning(`请输入每集时长`);
                return
            }
            if (Number(item.duration) < this.durationMin) {
                this.$message.warning(`每集时长低于${this.durationMin}分，已同步最低时长`);
                this.novelInfo.duration = this.durationMin
                return
            }
            if (Number(item.duration) > Number(this.durationLen)) {
                this.$message.warning(`每集时长超过${this.durationLen}分，已同步最高时长`);
                this.novelInfo.duration = this.durationLen
                return
            }
            for (let i in this.curForm) {
                let objItem = this.curForm[i]
                if (item.hasOwnProperty(objItem.key) && objItem.required && objItem.display) {
                    if (!item[objItem.key].trim()) {
                        this.$message.warning(`请输入${objItem.name}`);
                        return
                    }
                }
            }
            //在进行组合后端接收的格式
            // this.appendFormData(a=>{
            //     delete item[a.key]
            // })
            const removeKeys = new Set(this.appendFormData.map(obj => obj.key));

            //后台动态的数据
            let data = this.curForm.filter(obj => !removeKeys.has(obj.key));
            let settings = []
            data.forEach(c => {
                let obj = {
                    ...c,
                    "name": c.name,
                    "key": c.key,
                    "content": item[c.key] || '无'
                }
                settings.push(obj)
                //移除item里面动态参数
                delete item[c]
            })
            item.settings = settings
            item.protagonistNames = [item.protagonistNames]
            console.log('最后提交的内容=', item);
            this.loading = true
            SApi.djNovelAdd(item).then((res) => {
                if (res.code === 200) {
                    localStorage.removeItem(this.cacheKey)
                    this.$router.replace({ path: '/scriptSuccess', query: { successNovelId: res.data } })
                } else {
                    this.$message.warning(res.msg)
                }
            }).finally(() => {
                this.loading = false
            })
        },
        //停止生成
        stop(name, index) {
            this.$message.success('AI已停止生成！')
            this.clearTime()
            this.insertTextCaChe()
            // setTimeout(() => {
            //     this.empty()
            // }, 500);
        }

    }
}
</script>

<style>
#novel_create {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 10px;
}

.novel_create {
    padding: 35px 30px;
    height: 100%;
}

.AIicon:hover {
    opacity: 1 !important;
}

.novel_create3 .el-textarea .el-input__count,
.novel_create3 .el-input .el-input__count .el-input__count-inner {
    background: transparent;
}

.novel_create1 {
    font-weight: bold;
    font-size: 19px;
    color: #111111;
    display: flex;
    align-items: center;
}

.novel_create1 img {
    width: 23px;
    height: 23px;
    margin-right: 5px;
}

.novel_create2 {
    width: 100%;
    height: calc(100% - 50px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    margin: 0 auto;
    margin-top: 30px;
    padding-right: 60px;

}

.novel_create2_1 {
    width: 730px;
    margin: 0 auto;
}

.novel_create3 {
    display: flex;
    align-items: start;
    position: relative;
}

.novel_create4 {
    min-width: 150px;
    margin-right: 20px;
    font-size: 16px;
    color: #444444;
    text-align: right;
}

.novel_create4 span {
    color: #FF3030;
}

.novel_create5 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #666666;
    margin-right: 40px;
}

.novel_create5 img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
}

.novel_create6 {
    padding-left: 95px;
    font-size: 13px;
    color: #888888;
    margin-top: 10px;
    margin-bottom: 20px;
}

.novel_create6_1 {
    margin-bottom: 10px;
}

.el-input--suffix .el-input__inner {
    width: 625px;
    background-color: #F6F6F6;
}

.create_novel31 {
    position: relative;
}

.create_novel7 .el-input__inner,
.create_novel7 .el-textarea__inner {
    width: 625px;
    background-color: #F6F6F6;
    font-size: 15px;
    color: #666666;
    resize: none;
}

.el-input--suffix .el-input__inner::-webkit-input-placeholder,
.create_novel7 .el-input__inner::-webkit-input-placeholder,
.create_novel7 .el-textarea__inner::-webkit-input-placeholder {
    color: #777777;
    font-weight: 400;
    font-size: 15px !important;
    letter-spacing: 0;
}

/* .create_novel7 .el-textarea__inner::-webkit-scrollbar {
    display: none;
} */
/* input number类型取消增减箭头*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.novel_create8 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.novel_create8_1 {
    background: var(--tech-btn-Lightblue);
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 8px 8px;
    font-size: 15px;
    color: var(--tech-primary);
    margin-right: 10px;
    margin-bottom: 10px;
}

.novel_create8_1 img {
    width: 18px;
    height: 18px;
    margin-left: 5px;
}

.novel_create9 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: var(--tech-primary);
    padding: 5px 0;
    margin-bottom: 10px;
}

.novel_create9 img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
}

.create_novel10 {
    padding-left: 95px;
}

.create_novel11 {
    font-size: 13px;
    color: #548AFF;
    margin-top: 10px;
    margin-bottom: 20px;
}

.create_novel12 {
    width: 625px;
    padding: 13px;
    background-color: #FFEBEB;
    border-radius: 4px;
    font-size: 13px;
    color: #FF3030;
    margin-top: 10px;
}

.create_novel20 {
    display: flex;
    justify-content: flex-end;
    width: 625px;
    border-radius: 4px;
    font-size: 13px;
}

.create_novel13 {
    width: 625px;
    display: flex;
    justify-content: end;
}

.create_novel14 {
    width: 125px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border-radius: 8px;
    font-size: 15px;
    color: #A4A4A4;
    background: #EEEEEE;
    margin-top: 10px;
    cursor: no-drop;
}

.create_novel15 {
    color: #FFF;
    background: var(--tech-primary);
    cursor: default;
}

.create_novel15:hover {
    background-color: var(--tech-primary);
}

.create_novel16 {
    position: absolute;
    right: -150px;
    top: 0;
    /* width: 58px;
    height: 25px; */
    width: 85px;
    height: 32px;
    background: url('@/assets/image/icon_create1.png') no-repeat;
    background-size: 100% 100%;
}

.create_novel16:hover {
    background: url('@/assets/image/icon_create2.png') no-repeat;
    background-size: 100% 100%;
}

.create_novel30 {
    position: relative;
}

.loading_text_create {
    position: absolute;
    right: -178px;
    top: 3px;
    width: 19px;
    height: 19px;
}

.loading_text_create img {
    width: 100%;
    height: 100%;
    animation: rotate 1s linear infinite;
}

/* 定义旋转动画 */
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}
</style>